/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-09 17:31:35
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ProductList/index.tsx
 */
import React from 'react';

import _ProductList from 'src/components/Modules/ProductList';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';

const ProductList = (props) => {
  const {
    dynamicData,
    handleOnItemDelete,
    handleItemOnSort,
    droppableId,
    handleOnItemDeleteAll,
    handleOnReselect,
    staticData,
    handleOnStaticsChange,
    draggableId,
  } = props || {};

  return (
    <_ProductList
      onStaticChange={handleOnStaticsChange}
      staticData={staticData}
      products={dynamicData.map((i) => {
        const { productName } = i || {};
        return { ...(i || {}), name: productName };
      })} //products
      onItemDelete={handleOnItemDelete} //onItemDelete
      onItemSort={handleItemOnSort} //onItemSort
      onItemDeleteAll={handleOnItemDeleteAll} //onItemDeleteAll
      onItemReselect={handleOnReselect} //onItemReselect
      droppableId={droppableId} //droppableId
      draggableId={draggableId}
    />
  );
};
export default compose(ContentGroupHOC)(ProductList);
